import PageTitleComponent from "../../components/PageTitle";
import FeaturedProducts from "../../components/Products/Featured";

export default function FeaturedProductsScreen(){
return <div>
    <PageTitleComponent title="Featured Products" />
    <FeaturedProducts/>
</div>
}